export default {
    quizName: "考试",
    appName: "电子商务教序系统",
}